import { NgModule } from '@angular/core';

import { PreventDragDropDirective } from './prevent-dragdrop.directive';

@NgModule({
  declarations: [PreventDragDropDirective],
  exports: [PreventDragDropDirective],
})
export class PreventDragdropModule {}
export { PreventDragDropDirective } from './prevent-dragdrop.directive';
